export const ajaxResponseVm = {
    isError: false,
    errorMessage: null,
    data: null
};

export const ajaxVm = {
    ajaxUrl: '',
    ajaxType: 'GET',
    ajaxData: null,
    allowUnsuccessfulResponses: false
};

function get(url, data = null, allowUnsuccessfulResponses = false) {
    return ajaxCall({
        ...ajaxVm,
        ajaxUrl: url,
        ajaxData: data,
        allowUnsuccessfulResponses: allowUnsuccessfulResponses
    });
}

function post(url, data, allowUnsuccessfulResponses = false) {
    return ajaxCall({
        ...ajaxVm,
        ajaxUrl: url,
        ajaxType: 'POST',
        ajaxData: data,
        allowUnsuccessfulResponses: allowUnsuccessfulResponses
    });
}

function put(url, data, allowUnsuccessfulResponses = false) {
    return ajaxCall({
        ...ajaxVm,
        ajaxUrl: url,
        ajaxType: 'PUT',
        ajaxData: data,
        allowUnsuccessfulResponses: allowUnsuccessfulResponses
    });
}

function deleteRequest(url, data, allowUnsuccessfulResponses = false) {
    const vm = {
        ...ajaxVm,
        ajaxUrl: url,
        ajaxType: 'DELETE',
        ajaxData: data,
        allowUnsuccessfulResponses: allowUnsuccessfulResponses
    };

    return ajaxCall(vm);
}

export default {
    get,
    post,
    put,
    delete: deleteRequest
};

export function ajaxCall(vm) {
    return new Promise(function (resolve, reject) {

        const ajaxResponse = {
            ...ajaxResponseVm
        };

        //console.log(vm.ajaxUrl);
        //console.log(vm.ajaxData);

        $.ajax({
            url: vm.ajaxUrl,
            data: vm.ajaxData,
            type: vm.ajaxType,
            timeout: 180000, // 3 minutes
            contentType: vm.contentType,
            processData: vm.processData,
            beforeSend: function (xhr) {
                if (vm.requiresAuthentication)
                    setAuthorizationHeader(xhr);
            },
            success: function (data) {

                if (vm.excludeFromActionTaken === undefined || vm.excludeFromActionTaken === false) {

                    //app.timeout.stayLoggedInAction();
                }

                if (data.responseType) {

                    // ToDo: Add an undefined property in the view and see how this is handled. DW.
                    if (data.responseType && data.responseType === "PERMISSIONDENIED") {

                        //NOT IMPLEMENTED
                    }
                    else if (data.responseType && data.responseType === "DISPLAYEXCEPTIONALERT") {

                        //DISPLAYEXCEPTION is passed when we want to display an alert for the responseMessage content
                        alert(data.responseMessage);

                        reject(Error(data.responseMessage));
                    }
                    else if (data.responseType && data.responseType !== "SUCCESS") {

                        if (data.responseType === 'undefined') {
                            reject(Error('Unknown error.'));
                        }
                        else if (data.responseMessage === "Access denied") {
                            reject(Error('Sorry but you do not have access to this area.'));
                        }
                        //else {

                        //        //new property added to vm; allowUnsuccessfulResponses if true we allow responseType !== SUCCESS to pass back to calling service
                        //    if (!vm.allowUnsuccessfulResponses) {

                        //        //if it is not set, return a standard error result
                        //        reject(Error('The following error has occured: ' + data.responseMessage));
                        //    }
                        //}
                    }

                    //Return result of webservice call (returning a VM not HTML)
                    ajaxResponse.data = data;

                    resolve(ajaxResponse);

                }
                else {

                    //Falls in here if data is HTML

                    //The attempt to make a local ajax call redirected to the IS login page
                    //Should only occur if the timeout warning message fails to appear
                    //This should attempt to reload the page (like pressing F5) and redirect to IS to re-authenticate
                    if (data.hasOwnProperty('indexOf') && data.indexOf('login-background') > -1) {
                        window.location.reload(true);
                        reject(Error("Connection failure - please wait while this page reloads"));
                    }
                    else {

                        // ToDo: This doesn't work if an error returned from a local service call

                        // Update all controller actions which return html in applications.EDM to return the ajax response vm
                        // once this is done we can just return 'data' into the resolve function.
                        ajaxResponse.data = data;

                        resolve(ajaxResponse);
                    }

                }


            },
            error: function (jqXHR, exception) {

                var msg = '';
                if (jqXHR.status === 0) {
                    msg = 'Not connected. Verify Network.';
                } else if (jqXHR.status === 404) {
                    msg = 'Requested page not found [404].';
                } else if (jqXHR.status === 500) {
                    msg = 'Something has gone wrong displaying this page.';
                } else if (exception === 'parsererror') {
                    msg = 'Requested JSON parse failed.';
                } else if (exception === 'timeout') {
                    msg = 'Timeout error [408].';
                } else if (exception === 'abort') {
                    msg = 'Ajax request aborted.';
                } else {
                    msg = 'Something has gone wrong. ' + jqXHR.responseText + ' ' + exception;
                }

                reject(Error(msg));
            }
        });


    });
}

export function fileUpload(vm) {
    return new Promise(function (resolve, reject) {

        //app.timeout.stayLoggedInAction();

        const ajaxResponse = {
            ...ajaxResponseVm
        };

        $.ajax({
            url: vm.ajaxUrl,
            data: vm.ajaxData,
            type: vm.ajaxType,
            timeout: 600000, // 10 minutes
            cache: false,
            contentType: false,
            processData: false,
            beforeSend: function (xhr) {
                if (vm.requiresAuthentication)
                    setAuthorizationHeader(xhr);
            },
            xhr: function () {
                var myXhr = $.ajaxSettings.xhr();
                myXhr.timeout = 600000; //10 minutes
                if (myXhr.upload) {

                    // For handling the progress of the upload
                    myXhr.upload.addEventListener('progress', function (e) {
                        if (e.lengthComputable) {
                            $('progress').attr({
                                value: e.loaded,
                                max: e.total
                            });
                        }
                    }, false);
                }
                return myXhr;
            },
            success: function (data) {

                if (vm.requiresAuthentication) {

                    if (data.responseType && data.responseType === "FORCELOGOUT") {
                        //app.timeout.logoutUser(appSettings.LogoutReason_Forced);
                    }
                    else if (data.responseType !== "SUCCESS") {
                        if (data.responseType === 'undefined')
                            reject(Error('Unknown error.'));
                        else if (data.responseMessage === "Access denied")
                            reject(Error('Sorry but you do not have access to this area.'));
                        else
                            reject(Error('The following error has occured. ' + data.responseMessage));
                    }
                }

                ajaxResponse.data = data;
                resolve(ajaxResponse);
            },
            error: function (jqXHR, exception) {

                console.log("ERROR");
                console.log(jqXHR);
                console.log(exception);

                var msg = '';
                if (jqXHR.status === 0) {
                    msg = 'Not connected. Verify Network.';
                } else if (jqXHR.status === 404) {
                    msg = 'Requested page not found [404].';
                } else if (jqXHR.status === 500) {
                    msg = 'Internal Server Error [500].';
                } else if (exception === 'parsererror') {
                    msg = 'Requested JSON parse failed.';
                } else if (exception === 'timeout') {
                    msg = 'Timeout error [408].';
                } else if (exception === 'abort') {
                    msg = 'Ajax request aborted.';
                } else {
                    msg = 'Uncaught Error. ' + jqXHR.responseText;
                }

                reject(Error(msg));
            }
        });

    });
}

export function postToUrl(path, params, method) {

    //app.timeout.stayLoggedInAction();

    //allows you to dynamically create and submit forms.
    //sourced from: https://stackoverflow.com/questions/8003089/dynamically-create-and-submit-form
    method = method || "post";

    const form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);

    for (var key in params) {
        if (params.hasOwnProperty(key)) {
            var hiddenField = document.createElement("input");
            hiddenField.setAttribute("type", "hidden");
            hiddenField.setAttribute("name", key);
            hiddenField.setAttribute("value", params[key]);

            form.appendChild(hiddenField);
        }
    }

    //TODO: may need to hide form
    document.body.appendChild(form);
    form.submit();
}